import { Box } from '@rbilabs/universal-components';

export const StickyBoxChild = Box.withConfig<{ lastChild: boolean; spaces?: number }>(p => ({
  alignItems: 'center',
  justifyContent: 'center',
  flex: p.spaces || 1,
  marginRight: p.lastChild ? 0 : 4,
}));
